import { render, staticRenderFns } from "./DepositStats.vue?vue&type=template&id=4a6e470b&scoped=true"
import script from "./DepositStats.vue?vue&type=script&lang=js"
export * from "./DepositStats.vue?vue&type=script&lang=js"
import style0 from "./DepositStats.vue?vue&type=style&index=0&id=4a6e470b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e470b",
  null
  
)

export default component.exports